import { render, staticRenderFns } from "./IframeView.vue?vue&type=template&id=05363b90&scoped=true&"
import script from "./IframeView.vue?vue&type=script&lang=js&"
export * from "./IframeView.vue?vue&type=script&lang=js&"
import style0 from "./IframeView.vue?vue&type=style&index=0&id=05363b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05363b90",
  null
  
)

export default component.exports